"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = endpointMiddlewareFactory;

var _apiSelector = _interopRequireDefault(require("./api-selector.middleware"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function endpointMiddlewareFactory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(options.apis && options.apis.default && options.apis.default.apiUrl || process.env.REACT_APP_API_URL)) {
    throw new Error('You must specify API url either via options or REACT_APP_API_URL environment variable');
  }

  var defaultApi = options.apis && options.apis['default'] && options.apis['default'].apiUrl ? options.apis['default'] : {
    apiUrl: process.env.REACT_APP_API_URL
  };
  var config = {
    apis: _objectSpread({}, options.apis, {
      default: defaultApi
    }),
    excluded: options.excluded || ['http://', 'https://']
  };
  return (0, _apiSelector.default)(config);
}